<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button (click)="createUser()" color="primary" mat-button>New admin</button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortUsers($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      matSort>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="firstName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>First Name</th>
        <td *matCellDef="let element" mat-cell> {{element.firstName}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="lastName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Last Name</th>
        <td *matCellDef="let element" mat-cell> {{element.lastName}} </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
        <td *matCellDef="let element" mat-cell> {{element.email}} </td>
      </ng-container>

      <!-- Phone Column -->
      <ng-container matColumnDef="phone">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Phone</th>
        <td *matCellDef="let element" mat-cell> {{element.phone}} </td>
      </ng-container>

      <!-- Enabled Column -->
      <ng-container matColumnDef="enabled">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Enabled</th>
        <td *matCellDef="let element" mat-cell>
          <mat-icon class="correct-color" *ngIf="element.enabled">check_circle</mat-icon>
          <mat-icon class="error-color" *ngIf="!element.enabled">cancel</mat-icon>
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <button (click)="editUser(element)" [disabled]="disabled" mat-icon-button matTooltip="Edit admin">
              <mat-icon>edit</mat-icon>
            </button>
            <ng-container *ngIf="element.enabled && element.id !== loggedUser.id">
              <button (click)="changeAdminHabilitation(element)" *awIsInAnyRole="[roles.admin]" [disabled]="disabled"
                mat-icon-button matTooltip="Disable user">
                <mat-icon color="primary">toggle_on</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="!element.enabled && element.id !== loggedUser.id">
              <button (click)="changeAdminHabilitation(element)" *awIsInAnyRole="[roles.admin]" [disabled]="disabled"
                mat-icon-button matTooltip="Enable user">
                <mat-icon>toggle_off</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="element.id !== loggedUser.id">
              <button (click)="deleteUser(element)" *awIsInAnyRole="[roles.admin]" [disabled]="disabled" mat-icon-button
                matTooltip="Delete admin">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">No admins found</td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorAdmins [fxShow]="dataSource && dataSource.data.length > 10" [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>